module.exports = {
	"articleTitle1": "Starbucks attempts to conquer Ann Arbor coffee scene",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Starbucks",
	"articleLink1": "https://www.michigandaily.com/content/starbucks-attempts-conquer-ann-arbor-coffee-scene",
	"articleLink2": "https://www.michigandaily.com/news/tim-hortons-open-shop-south-u",
	"articleSnippet1": "Nov 1, 2001 ... Of course then they\"ll gladly tell you exactly what corner of State Street it\"s on and \nhow far the other one down South University Street is, ...",
	"articleSnippet2": "Dec 3, 2012 ... Employees at popular coffee shops in the South University ... Justin Hood, \nmanager of the Starbucks location on South University, ...",
	"foodRecommendations": [],
	"articleTitle2": "Tim Hortons to open Thursday in Landmark",
	"address": "1214 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.274645,
		"lng": -83.733924
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/starbuckssouthu.json
// module id = 979
// module chunks = 0